var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-embed',{ref:"banner-main-video",attrs:{"type":"video","aspect":"16by9","controls":""},on:{"play":_vm.changeVideoStartTime}},[_c('source',{attrs:{"src":_vm.videoUrl + `#t=${_vm.videoTimeStamp}`,"type":"video/mp4"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }